import * as React from 'react';
import { Stepper } from './Stepper';
import { Theme } from '@theme/base';
import {
  BookingSteps,
  bookingSteps,
  bookingStepsToPagesMapping,
  toursBookingSteps,
  toursBookingStepsToPagesMapping
} from '@model/common';
import { useDispatch, useSelector } from 'react-redux';
import { navigateBack } from '@state/basket';
import { getDealFinderLastSearchType } from '@state/slices/deal-finder-last-searched/dealFinderLastSearchedSelectors';
import {
  getDealFinderDestinationSearch,
  getDealFinderHotelLandingSearch
} from '@state/slices/deal-finder/dealFinderSelectors';
import { getIsTourSearchTypeByType, getTourLandingSearch } from '@state/slices/search/tours';
import { TripTypes } from '@model/common/tours/trip-types';

export interface StepperContainerProps {
  theme?: Theme;
  testId?: string;
  currentStep: BookingSteps;
  isGhosting?: boolean;
  isTour?: boolean;
  tripType?: TripTypes;
}

export const StepperContainer = ({ currentStep, testId, isGhosting, isTour, tripType }: StepperContainerProps) => {
  const dispatch = useDispatch();
  const searchType = useSelector(getDealFinderLastSearchType);
  const hotelLandingSearch = useSelector(getDealFinderHotelLandingSearch);
  const destinationSearch = useSelector(getDealFinderDestinationSearch);
  const tourSearchByTripType = !!tripType && useSelector(getIsTourSearchTypeByType(tripType));
  const isTourSearch = !!isTour && tourSearchByTripType;
  const isTourLandingSearch = useSelector(getTourLandingSearch);

  const steps = isTour
    ? toursBookingSteps(isTourSearch, isTourLandingSearch)
    : bookingSteps({ searchType, hotelLandingSearch, destinationSearch });
  const handleOnClick = async (step: BookingSteps) => {
    const newStep = isTour ? toursBookingStepsToPagesMapping[step] : bookingStepsToPagesMapping[step];
    dispatch(navigateBack(newStep));
  };
  const activeStep = steps.indexOf(currentStep);

  return (
    <Stepper testId={testId} activeStep={activeStep} onClick={!isGhosting ? handleOnClick : () => {}} steps={steps} />
  );
};
